module.exports = __webpack_public_path__ + "img/footer-logo.433ca850.svg";